import React from "react";
import '../assets/styles/Testimonial.scss';

const testimonials = [
  {
    text: (
      <>
        Ahmad played a pivotal role in the development and deployment of our fintech app,
        serving as the solution architect responsible for design, deployment, and optimization.
        Throughout our year-and-a-half engagement, he demonstrated exceptional expertise by
        meticulously designing, building, and managing our entire cloud infrastructure across
        multiple availability zones, ensuring optimal performance, uptime, scalability, and security.
        Ahmad's infectious can-do attitude made him a pleasure to work with. His commitment to
        staying up-to-date with the latest AWS solutions and advancements was evident in his
        proactive approach and continuous contributions to the project's success.{' '}
        <strong>I highly recommend Ahmad's involvement, advice, and expertise in any cloud project.</strong>
      </>
    ),
    name: "Hasan F.",
    role: "Fintech Integration & Support Lead — Bede, by Zain Bahrain",
  },
  {
    text: (
      <>
        Ahmad excelled as a Solution Architect, after originally joining my team as a Systems Administrator.
        His ability to swiftly take on more complex responsibilities while driving key infrastructure
        initiatives made him a standout team member. He consistently approached his work with a focus on
        scalability, efficiency, and redundancy, helping design and implement solutions that met evolving
        business needs. One of his most significant contributions was the design and launch of a new service
        that required coordination across multiple departments and building complex components from scratch.{' '}
        <strong>
          I was continually impressed by Ahmad's work ethic, ownership, and dedication to the team.
          I highly recommend Ahmad for any fast-paced and technically challenging roles.
        </strong>
      </>
    ),
    name: "Ahmad A.",
    role: "Founder @ BeyondBits | PMP | 3x AWS Certified",
  },
];

function Testimonial() {
  return (
    <div className="container" id="testimonial">
      <div className="testimonial-container">
        <span className="testimonial-tag">{'// What Clients Say'}</span>
        <div className="testimonial-grid">
          {testimonials.map((t, i) => (
            <div className="testimonial-card" key={i}>
              <div className="testimonial-quote-mark">"</div>
              <blockquote className="testimonial-text">{t.text}</blockquote>
              <div className="testimonial-author">
                <div className="testimonial-author-info">
                  <span className="testimonial-name">{t.name}</span>
                  <span className="testimonial-role">{t.role}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Testimonial;
